import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class NumberOfMovesExceeded extends HundredBricksAPIError {
    constructor(options) {
        super('The number of moves exceeds the allowed limit', options);
    }
}
export default NumberOfMovesExceeded;
